"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIST_RENDER_TYPE = exports.LIST_TYPE = exports.DEFAULT_PROVIDER_TILE_MAX_LOCATIONS = exports.PROVIDER_LOGO_MAX_WIDTH_PX_COUNT = exports.SLOTS_ERROR_STATUS = exports.SLOTS_SUCCESS_STATUS = exports.SLOTS_LOADING_STATUS = exports.READ_ONLY_MAX_AVAILABILITIES_TO_DISPLAY = exports.MAX_AVAILABILITIES_TO_DISPLAY = exports.MAP_LOCATION_FIELDS = exports.MAP_BASE_URL = exports.ALL_LOCATION_HEADERS = exports.MAX_BADGE_FIELDS = exports.PROVIDER_TYPES = exports.PURPOSE_USE_TYPE = exports.VISIBILITIES = exports.VISIT_TYPES = exports.LOGGING = exports.DEFAULTS = void 0;
exports.DEFAULTS = {
    BADGE_FIELDS: [{ field: 'accepting_new_patients' }],
    PROVIDER_RATING_SCALE: 5,
    SUMMARY_DATA: [
        {
            field: 'specialties',
            subfield: 'name',
            secondary_subarray: 'subspecialties',
            secondary_subfield: 'name'
        },
        { field: 'hospital_affiliations', display_as: 'Affiliations' }
    ]
};
exports.LOGGING = {
    MESSAGE: {
        CALL_TO_ACTION: 'user_action.cta',
        REQUEST_APPOINTMENT: 'user_action.alter_view.request_appointment',
        VIEW_PROVIDER: 'user_action.search_results.view_provider',
        MAP_LINK_CLICKED: 'user_action.search_results.map_link_clicked',
        MYCHART_LOGIN_CLICKED: 'user_action.mychart_login.clicked',
        PROVIDER_TAB_CLICKED: 'user_action.tab.clicked',
        PROVIDER_TAB_TABLE_SEARCH: 'user_action.tab.table_search',
        PRACTICE_GUIDE_TAB_CLICKED: 'user_action.practice_guide.tab.clicked',
        PRACTICE_GUIDE_VIEWED: 'user_action.practice_guide.viewed',
        SHOW_MORE_CLICKED: 'user_action.show_more.clicked',
        SHOW_LESS_CLICKED: 'user_action.show_less.clicked',
        APPOINTMENT_INFO_CHANGED: 'user_action.appointment_info.changed',
        PROVIDER_TABS_RICH_TEXT_LINK_CLICKED: 'user_action.provider_tabs.rich_text.link_clicked',
        VIEW_AVAILABILITY: 'user_action.provider_card.view_availability',
        VIEW_AVAILABILITY_OPEN_SCHEDULING_CLICKED: 'user_action.provider_profile.open_scheduling.view_availability',
        SIMILAR_PROVIDER_VIEW_PROVIDER_PROFILE: 'user_action.click.similar_provider_profile',
        CARE_TEAM_VIEW_PROVIDER_PROFILE: 'user_action.click.care_team_provider_profile_link',
        SIMILAR_PROVIDER_VIEW_AVAILABILITY_CTA: 'user_action.similar_provider.book.CTA',
        CARE_TEAM_VIEW_AVAILABILITY_CTA: 'user_action.care_team_provider.book.CTA',
        CARE_TEAM_VIEW_PROVIDER_PROFILE_CTA: 'user_action.click.care_team_provider_profile_CTA',
        PROFILE_RATING_REVIEW_COUNT_CLICKED: 'user_action.click.provider_profile_rating_review_count'
    },
    PAGE_SECTION: {
        PROVIDER_IMAGE: 'provider_image',
        PROVIDER_NAME: 'provider_name',
        REVIEW_COUNT: 'review_count',
        LOCATIONS: 'provider_locations'
    },
    PLACEMENTS: {
        PROVIDER_CARD: 'provider_card'
    }
};
exports.VISIT_TYPES = {
    PHONE: 'phone',
    VIDEO: 'video',
    IN_PERSON: 'in_person'
};
exports.VISIBILITIES = {
    CONSUMER: 'consumer',
    AGENT: 'agent'
};
exports.PURPOSE_USE_TYPE = {
    DIRECT_BOOK: 'direct_book',
    HIDDEN: 'hidden'
};
exports.PROVIDER_TYPES = {
    VIRTUAL_CARE: 'Virtual Care'
};
exports.MAX_BADGE_FIELDS = 6;
exports.ALL_LOCATION_HEADERS = [
    'phone',
    'fax',
    'distance'
];
exports.MAP_BASE_URL = 'https://www.google.com/maps';
exports.MAP_LOCATION_FIELDS = [
    'street1',
    'street2',
    'suite',
    'city',
    'state',
    'zip'
];
exports.MAX_AVAILABILITIES_TO_DISPLAY = 3;
exports.READ_ONLY_MAX_AVAILABILITIES_TO_DISPLAY = 4;
exports.SLOTS_LOADING_STATUS = '@slots/loading';
exports.SLOTS_SUCCESS_STATUS = '@slots/success';
exports.SLOTS_ERROR_STATUS = '@slots/error';
exports.PROVIDER_LOGO_MAX_WIDTH_PX_COUNT = 110;
exports.DEFAULT_PROVIDER_TILE_MAX_LOCATIONS = 3;
exports.LIST_TYPE = {
    HIERARCHY: 'hierarchy'
};
exports.LIST_RENDER_TYPE = {
    HIERARCHY: 'hierarchy',
    FLAT: 'flat'
};
//# sourceMappingURL=globals.js.map